import request from './common/request'
import qs from 'qs'
import { MERCHANT_CERTIFICATE_TEMPLATE_URI } from './urls'

/**
 * 证书模板分页列表
 * @param {Object} params
 * @param {number} [params.page=1] 页码
 * @param {number} [params.pageSize=10] 每页条数
 * @param {string} [params.templateNameLike] 模板名称模糊查询
 * @param {number} [params.status] 状态：1 启用等
 * @returns {Promise<*>}
 */
export const query = async (params = {}) => {
  const queryParams = {
    page: params.page != null ? params.page : 1,
    pageSize: params.pageSize != null ? params.pageSize : 10
  }
  if (params.status != null && params.status !== '') {
    queryParams.status = params.status
  }
  const templateNameLike =
    params.templateNameLike != null ? String(params.templateNameLike).trim() : ''
  if (templateNameLike) {
    queryParams.templateNameLike = templateNameLike
  }
  return request({
    url: `${MERCHANT_CERTIFICATE_TEMPLATE_URI}/query`,
    method: 'GET',
    params: queryParams,
    paramsSerializer: (p) => qs.stringify(p, { skipNulls: true })
  })
}

/**
 * 证书模板详情
 * @param {number|string} id 模板 ID
 * @returns {Promise<*>}
 */
export const findById = async (id) => {
  return request({
    url: `${MERCHANT_CERTIFICATE_TEMPLATE_URI}/${id}`,
    method: 'GET'
  })
}

/**
 * 更新证书模板（字段均可选，只传需要修改的）
 * @param {number|string} id 模板 ID
 * @param {Object} data
 * @param {string} [data.templateName]
 * @param {string} [data.backgroundImageUrl]
 * @param {string} [data.layoutOrientation]
 * @param {string} [data.layoutJson]
 * @param {string} [data.sealImageUrl]
 * @param {number} [data.status]
 * @returns {Promise<*>}
 */
export const updateById = async (id, data = {}) => {
  const body = {}
  if (data.templateName != null && data.templateName !== '') {
    body.templateName = data.templateName
  }
  if (data.backgroundImageUrl != null && data.backgroundImageUrl !== '') {
    body.backgroundImageUrl = data.backgroundImageUrl
  }
  if (data.layoutOrientation != null && data.layoutOrientation !== '') {
    body.layoutOrientation = data.layoutOrientation
  }
  if (data.layoutJson != null && data.layoutJson !== '') {
    body.layoutJson = data.layoutJson
  }
  if (data.sealImageUrl != null && data.sealImageUrl !== '') {
    body.sealImageUrl = data.sealImageUrl
  }
  if (data.status != null) {
    body.status = data.status
  }
  return request({
    url: `${MERCHANT_CERTIFICATE_TEMPLATE_URI}/${id}`,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: body
  })
}

/**
 * 创建证书模板
 * @param {Object} data
 * @param {string} data.templateName 模板名称
 * @param {string} data.backgroundImageUrl 背景图完整 URL
 * @param {string} data.layoutOrientation portrait | landscape
 * @param {string} data.layoutJson 字段布局 JSON 字符串
 * @param {string} [data.sealImageUrl] 印章图 URL
 * @param {number} [data.status=1] 状态
 * @returns {Promise<*>}
 */
/**
 * 删除证书模板
 * @param {number|string} id 模板 ID
 * @returns {Promise<*>}
 */
export const deleteById = async (id) => {
  return request({
    url: `${MERCHANT_CERTIFICATE_TEMPLATE_URI}/${id}`,
    method: 'DELETE'
  })
}

export const create = async (data = {}) => {
  const body = {
    templateName: data.templateName,
    backgroundImageUrl: data.backgroundImageUrl,
    layoutOrientation: data.layoutOrientation || 'portrait',
    layoutJson: data.layoutJson,
    status: data.status != null ? data.status : 1
  }
  if (data.sealImageUrl) {
    body.sealImageUrl = data.sealImageUrl
  }
  return request({
    url: MERCHANT_CERTIFICATE_TEMPLATE_URI,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: body
  })
}



// WEBPACK FOOTER //
// ./src/api/merchant-certificate-template.js